import { Component, Input, OnInit } from '@angular/core';
import { GmbLocation } from '@boxx/OAuth';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-account-select',
  templateUrl: './gmb-account-select.component.html',
  styleUrls: ['./gmb-account-select.component.scss'],
})
export class GmbAccountSelectComponent implements OnInit {
  @Input() locations: GmbLocation[];
  @Input() profile: { profilePhotoUrl: string; accountName: string };

  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {}

  selectLocation(index: number) {
    this.modalCtrl.dismiss({ index });
  }
}
